export default __webpack_public_path__ + "static/media/grid4x4.3b89119f.svg";